import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const links = [
    { label: t(($) => $.security), href: 'https://myosh.com/security/' },
    { label: t(($) => $.privacy), href: 'https://myosh.com/privacy/' },
    { label: t(($) => $.termsAndConditions), href: 'https://myosh.com/terms-and-conditions/' },
  ];

  return (
    <footer
      data-testid="login-footer"
      className="mt-auto flex w-full flex-col gap-1 bg-muted px-8 py-8 text-foreground md:px-24"
    >
      <nav aria-label={t(($) => $.legal)}>
        <ul className="flex flex-wrap">
          {links.map(({ label, href }) => (
            <li key={href} className="[&:not(:first-child)]:before:mx-2 [&:not(:first-child)]:before:content-['|']">
              <a className="font-semibold text-secondary-2 hover:underline" href={href}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      <p className="font-semibold">{t(($) => $.loginFooterCopyright, { year: new Date().getFullYear() })}</p>
    </footer>
  );
};

export default Footer;
